import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';

import { TYPES } from './constants';
import AlertIcon from './WarningIcon';

export { TYPES };

const Alert = ({ message, type }) => (
  <div className="Alert">
    {type === TYPES.WARNING && (
      <div className="Alert__icon">
        <AlertIcon />
      </div>
    )}
    <div className="Alert__message">{message}</div>
    <style jsx>
      {`
        .Alert {
          display: flex;
          flex-direction: row;
          width: 100%;
        }

        .Alert__icon {
          margin-left: ${Theme.get('spacing') * 0.25}px;
          margin-right: ${Theme.get('spacing') * 2.25}px;
          display: flex;
          align-items: center;
        }

        .Alert__message {
          color: ${Theme.get('colors-black')};
          font-size: ${Theme.get('font-size-small-px')};
          font-weight: ${Theme.get('font-weight-normal')};
          letter-spacing: ${Theme.get('letter-spacing-px')};
          line-height: ${18}px;
          text-align: left;
        }
      `}
    </style>
  </div>
);

Alert.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(TYPES)),
};

Alert.defaultProps = {
  type: TYPES.DEFAULT,
};

export default Alert;
